import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  // State
  const user = ref(null)
  const loading = ref(false)
  const initialized = ref(false)

  // Getters
  const isAuthenticated = computed(() => !!user.value)
  const creditsBalance = computed(() => user.value?.credits_balance || 0)
  const creditsBalanceDollars = computed(() => (creditsBalance.value ).toFixed(2))
  const hasLowCredits = computed(() => creditsBalance.value <= 3)
  const hasCriticalCredits = computed(() => creditsBalance.value <= 1)

  // Actions
  async function fetchCurrentUser() {
    loading.value = true
    try {
      const response = await fetch('/api/current_user', {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (response.ok) {
        const data = await response.json()
        user.value = data
      } else {
        user.value = null
      }
    } catch (error) {
      console.error('Failed to fetch user:', error)
      user.value = null
    } finally {
      loading.value = false
      initialized.value = true
    }
  }

  async function logout() {
    try {
      const csrfToken = document.querySelector('[name="csrf-token"]')?.content
      await fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      })
      user.value = null
      window.location.href = '/'
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  function updateCredits(newBalance) {
    if (user.value) {
      user.value.credits_balance = newBalance
    }
  }

  return {
    // State
    user,
    loading,
    initialized,
    // Getters
    isAuthenticated,
    creditsBalance,
    creditsBalanceDollars,
    hasLowCredits,
    hasCriticalCredits,
    // Actions
    fetchCurrentUser,
    logout,
    updateCredits
  }
})